import {
  Box,
  Table as ChakraTable,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  IconButton,
  Input,
  Tbody,
  Td,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import { FaPause, FaPlay } from "react-icons/fa";
import Loader from "../../utils/Loader/Loader";
import { toast } from "react-toastify";

const VoicesTable = ({
  columns,
  data,
  loading,
  getProvicerIcon,
  queries,
  previewDefaultAudio,
  getVoiceOwnerIcon,
  getSubHeadingDescriptionLabel,
  setQueries,
}) => {
  const audioRefs = useRef({});
  const [playingAudioId, setPlayingAudioId] = useState(null);

  const toggleAudio = (id, previewUrl) => {
    let currentAudio = audioRefs.current[id];
    if (playingAudioId === id) {
      currentAudio?.pause();
      setPlayingAudioId(null);
      return;
    }
    if (playingAudioId && audioRefs.current[playingAudioId]) {
      audioRefs.current[playingAudioId].pause();
      audioRefs.current[playingAudioId].currentTime = 0;
    }

    if (!currentAudio) {
      currentAudio = new Audio(previewUrl);
      audioRefs.current[id] = currentAudio;
      currentAudio.onended = () => {
        setPlayingAudioId(null);
      };
    }

    currentAudio.play().catch((e) => {
      toast("Audio can't be played");
    });
    setPlayingAudioId(id);
  };

  const filteredData = data;

  return (
    <Box shadow="sm" borderRadius="md" overflowY="auto" h={"100%"}>
      <Flex gap={2} alignContent="flex-end">
        <FormControl>
          <FormLabel>Search</FormLabel>
          <Input
            placeholder="Search..."
            onChange={(e) => {
              setQueries((prevQueries) => ({
                ...prevQueries,
                search: e.target.value,
              }));
            }}
            value={queries?.search}
            mb={3}
          />
        </FormControl>
      </Flex>
      {loading ? (
        <Box textAlign="center" py={5}>
          <Loader />
        </Box>
      ) : filteredData?.length === 0 ? (
        <Box textAlign="center" py={5} fontSize="lg" fontWeight="bold">
          No Voices Available
        </Box>
      ) : (
        <ChakraTable width="100%">
          <Thead>
            <Tr backgroundColor="#FAFAFA">
              {columns.map((column) => (
                <Th
                  textAlign={
                    column === "Provider" || column === "Owner Type"
                      ? "center"
                      : "left"
                  }
                  borderBottom="1px"
                  borderColor="#E4E4E7"
                  key={column}
                >
                  {column}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {filteredData?.map((voice) => {
              const labels = voice?.attributes?.properties?.labels;
              return (
                <Tr key={voice.id}>
                  <Td>
                    <Tooltip
                      label={voice.voicetts_provider}
                      textTransform="capitalize"
                    >
                      <Flex justifyContent="space-around">
                        <Icon
                          as={getProvicerIcon(voice.voicetts_provider)}
                          size="sm"
                        />
                      </Flex>
                    </Tooltip>
                  </Td>
                  <Td textTransform="capitalize">{voice.language_group}</Td>
                  <Td>{voice.name}</Td>
                  <Td>{getSubHeadingDescriptionLabel(labels)}</Td>
                  <Td>
                    <Tooltip
                      label={getVoiceOwnerIcon(voice.owner_type).label}
                      textTransform="capitalize"
                    >
                      <Flex justifyContent="space-around">
                        <Icon
                          as={getVoiceOwnerIcon(voice.owner_type).icon}
                          size="sm"
                        />
                      </Flex>
                    </Tooltip>
                  </Td>
                  <Td>
                    <IconButton
                      size="sm"
                      ml={3}
                      icon={
                        playingAudioId === voice.id ? <FaPause /> : <FaPlay />
                      }
                      colorScheme="blue"
                      onClick={async () => {
                        const previewUrl = voice.attributes?.preview_url
                          ? voice.attributes?.preview_url
                          : await previewDefaultAudio(voice?.id);
                        toggleAudio(voice.id, previewUrl);
                      }}
                      aria-label="Play/Pause Audio"
                    />
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </ChakraTable>
      )}
    </Box>
  );
};

export default VoicesTable;
